import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import axiosInstance from '../../../axiosInstance';

const Shops = () => {
    const [shops, setShops] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [editingShop, setEditingShop] = useState(null);

    useEffect(() => {
        fetchShops();
    }, []);

    const fetchShops = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/shops');
            if (response.data.shops) {
                setShops(response.data.shops);
            } else {
                message.error('Failed to fetch shops.');
                setShops([]);
            }
        } catch (error) {
            console.error(error);
            message.error('Failed to fetch shops.');
            setShops([]);
        } finally {
            setLoading(false);
        }
    };

    const showModal = (shop = null) => {
        if (shop) {
            setEditingShop(shop);
            form.setFieldsValue(shop);
        } else {
            setEditingShop(null);
            form.resetFields();
        }
        setIsModalVisible(true);
    };

    const handleOk = async (values) => {
        try {
            let response;
            if (editingShop) {
                response = await axiosInstance.put(`/shops/update/${editingShop.id}`, values);
                message.success('Shop updated successfully');
            } else {
                response = await axiosInstance.post('/shops/register', values);
                message.success('Shop added successfully');
            }
            fetchShops();
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            message.error('Failed to save shop.');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, shop) => (
                <Button onClick={() => showModal(shop)}>Edit</Button>
            ),
        },
    ];

    return (
        <div>
            <div style={{ textAlign: 'right', marginBottom: 16 }}>
                <Button type="primary" onClick={() => showModal()}>
                    Add Shop
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={Array.isArray(shops) ? shops : []}
                rowKey="id"
                pagination={{ pageSize: 25 }}
                scroll={{ x: 'max-content' }}
                loading={loading}
            />

            <Modal
                title={editingShop ? 'Edit Shop' : 'Add New Shop'}
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                okText={editingShop ? 'Update' : 'Add'}
                cancelText="Cancel"
                destroyOnClose
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleOk}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Please input the shop name!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="location"
                        label="Location"
                        rules={[{ required: true, message: 'Please input the shop location!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="Description"
                        rules={[{ required: true, message: 'Please input the shop description!' }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[
                            { required: true, message: 'Please input the phone number!' },
                            { pattern: /^\d{10,15}$/, message: 'Please enter a valid phone number!' }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Please input the email address!' },
                            { type: 'email', message: 'Please enter a valid email address!' }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Shops;
